import { boot } from 'quasar/wrappers'
import { Plugins } from '@capacitor/core'
import { Platform } from 'quasar'
const { App } = Plugins

export default boot(({ router, store }) => {
	App.addListener('appUrlOpen', (data) =>{
		const url = new URL(data.url)

		const parts = url.split('token=');
		const token = parts[1];
		
		if (token) {
			alert('atualizou'+token)
		}

		if (url.pathname !== '/' || url.search !== '') {
			router.push({
				path: `${url.pathname === '/' ? '/home': url.pathname}${url.search}`
			})
		}
	})
	if (Platform.is.ios) {
		App.addListener('appUrlOpen', (event) => {
			// Obtenha a URL que abriu o aplicativo
			const url = event.url;
	
			// Faça algo com a URL, por exemplo, redirecionar para uma rota específica
			const urlPath = url.split('.app').pop(); // Ajuste conforme necessário
			if (urlPath) {
				const parts = urlPath.split('token=');
				const token = parts[1];
				if (token) {
					store.dispatch('redirect/SET_TOKEN', [token])
					router.push({
						path: `/login`
					})
				}
			}
		});
	}
})
